import React from 'react';

const AppleIcon: React.FC = () => (
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.0729 5.68125C12.9854 5.75 11.4979 6.625 11.4979 8.45625C11.4979 10.5687 13.4229 11.3375 13.4729 11.3375C13.4604 11.3875 13.1479 12.4687 12.4104 13.575C11.7604 14.5437 11.0729 15.5187 9.99789 15.5187C8.97289 15.5187 8.64789 14.8937 7.47289 14.8937C6.23539 14.8937 5.91039 15.5187 4.94789 15.5187C3.87289 15.5187 3.13539 14.4875 2.44789 13.5312C1.63539 12.4062 0.947891 10.6125 0.947891 8.9C0.947891 6.05625 2.71039 4.575 4.43539 4.575C5.42289 4.575 6.24789 5.25625 6.85039 5.25625C7.42289 5.25625 8.32289 4.54375 9.44789 4.54375C9.89789 4.54375 11.8479 4.575 13.0729 5.68125ZM9.27289 2.54375C9.77289 1.94375 10.1229 1.1125 10.1229 0.28125C10.1229 0.18125 10.1104 0.08125 10.0979 0C9.32289 0.025 8.41039 0.48125 7.84789 1.14375C7.38539 1.68125 6.96039 2.5125 6.96039 3.35625C6.96039 3.46875 6.98539 3.58125 6.99789 3.61875C7.04789 3.63125 7.12289 3.64375 7.19789 3.64375C7.89789 3.64375 8.74789 3.21875 9.27289 2.54375Z" />
  </svg>
);

export default AppleIcon; 